export default {
    companyHoliday: 'วันหยุดบริษัท',
    searchByHolidayName: 'ค้นหาโดยชื่อวันหยุด',
    search: 'ค้นหา',
    createNewHoliday: 'สร้างวันหยุดใหม่',
    holidayName: 'ชื่อวันหยุด',
    holidayDate: 'วันที่หยุด',
    dateCreate: 'วันที่สร้าง',
    description: 'คำอธิบาย',
    companyHolidayIsDeleted: 'วันหยุดบริษัทถูกลบแล้ว',
    congratulation: 'ยินดีด้วย',
    deleteCompanyHoliday: 'ลบวันหยุดบริษัท',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบสาขา'
}
